import React from "react";

import { Navigate, Outlet } from "react-router-dom";

const PrivateRoutes = (props) => {
    const auth = localStorage.getItem('auth_name');
    return auth ? <Outlet/>: <Navigate to="/"/>
}
export default PrivateRoutes;